import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { LOCALE_ID, Inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { MetaService } from 'src/app/core/services/meta.service';
import { DataService } from 'src/app/core/services/data.service';
import { NavService } from 'src/app/core/services/nav.service';
import { ActivatedRoute } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { StoriesService } from 'src/app/core/services/stories.service';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScholarshipComponent } from '../../components/scholarship/scholarship.component';
declare let gtag: Function;

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, AfterViewInit {
  @ViewChild('slideBlock', { static: false }) slideBlock!: ElementRef;
  private scrollTimeout: any;

  fileBase = `${environment.apiBaseUrl}/story/file//`;

  public brands: any[] = [];
  allStories: any[] = [];
  displayStories: any[] = [];
  brandNavigator: string = "bi-chevron-right";
  isScrolledToEnd: boolean = false;
  isScrolledToStart: boolean = true;
  autoScrollInterval: any = null;

  showList = false;

  loading = false;

  public constructor(public modalService: NgbModal,private route: ActivatedRoute, @Inject(LOCALE_ID) public locale: string, private data: DataService, private storySrv: StoriesService, private navSrv: NavService, private scroller: ViewportScroller) {
    navSrv.clearBreadcrumbs();

  }

  getCurrentLang() {
    return this.locale;
  }

  ngOnInit(): void {
    // this.autoSchol();

    // Get the current URL
    const fragment = this.route.snapshot.fragment; // This gives you the URL as a string

    setTimeout(() => {
      const fragment = this.route.snapshot.fragment;
      if (fragment === 'dp-programs') {
        this.scroller.scrollToAnchor('dp-programs');
      }
    }, 1000);


    this.data.brands.subscribe(brands => this.brands = brands);

    this.storySrv.getStories(this.locale).subscribe((response) => {
      this.allStories = response.items;
      this.displayStories = response.items;
      // Filter stories based on the desired locale
      // this.displayStories = this.allStories[0][this.locale];
    });


  }

  ngAfterViewInit(): void {
    // const fragment = this.route.snapshot.fragment;
    // if (fragment === 'dp-programs') {
    //   this.scroller.scrollToAnchor('dp-asd');
    // }
  }

  visit(brand: any) {
    gtag('event', 'DP_SITE_LINK', {
      'event_category': 'LINK_CLICK',
      'event_label': 'brand',
      'value': brand.name
    })
  }

  // autoSchol() {
  //   const modelRef = this.modalService.open(ScholarshipComponent, { centered: true, backdrop: true });
  //   modelRef.componentInstance.modalRef = modelRef;
  // }

}
